<div class="container-fluid container-fluid-wrap">
    <sync-error [errcode]="errcode" style="position: relative; top: 10px;"></sync-error>
    <div class="row">
        <div class="invite-content-box col-sm-offset-3 col-sm-6">
            <h2 class="text-center" style="margin-bottom: 20px;">
                {{ acceptSuccess ? 'Account Transfer in Progress' : 'Account Transfer Notice' }}
            </h2>
            <div class="invite-content" *ngIf="spinner">
                <i class="fa fa-spin fa-spinner"></i>
                {{ 'Processing on Account Transfer....' }}
            </div>
            <div *ngIf="isInviteChecked && isInviteValid && !spinner">
                <div class="invite-content" *ngIf="!declineSuccess && !acceptSuccess" style="text-align: left;">
                    <ng-container *ngIf="!show2FA">
                        <p>You’ve shown interest in upgrading your organization’s account. By accepting this invitation:</p>
                        <ol>
                            <li><p>Your account will be upgraded to a {{ upgradProductName }}, inheriting all associated features.</p></li>
                            <li><p>Your files, folders, shares, links, and selective sync settings will remain unaffected.</p></li>
                            <li><p>You will need to re-authorize Sync on your computers and devices once the transfer is completed.</p></li>
                            <li>
                                <p>All Sync accounts associated with your organization will be temporarily be disabled during the transfer, which may take up to 48 hours.</p>
                                <ol type="a">
                                    <li>
                                        <p>Please ensure that all Sync users associated with the account take action on their end to ensure smooth transition and no delays.</p>
                                    </li>
                                </ol>
                            </li>
                            <li><p>You'll receive an email notification once the transfer is complete.</p></li>                            
                        </ol>
                    </ng-container>
                    <ng-container *ngIf="!show2FA">
                        <p><b>Action Required:</b></p>
                        <ol>
                            <li><p><a href="https://www.sync.com/install/" target="_blank">Click here</a> to ensure that you have the latest version of the Sync application installed.</p></li>
                            <li><p><a href="javascript:void(0)" (click)="sendEmailToTeamMembers()">Click here</a> to inform your team members to install the latest Sync application. This will trigger an email to your team members.</p></li>                            
                        </ol>
                        <p>These steps are mandatory to ensure that all devices are up-to-date and the migration is successful.</p>
                    </ng-container>
                    <ng-container *ngIf="show2FA">
                        <p>Please enter your 2FA (2-factor authentication) code received in your email. This code confirms that you were invited by <b>{{invitee}}</b>.</p>
                    </ng-container>
                    <hr />
                    <form *ngIf="isInviteChecked" [formGroup]="passwordForm" ngNativeValidate>
                        <ng-container *ngIf="!show2FA">
                            <div class="form-group">
                                <label>Your email address:</label>
                                <input type="email" name="email" id="email" class="input-lg form-control login-form-control" size="30"
                                    placeholder="Email" required formControlName="email" />
                            </div>
                            <div class="form-group">
                                <label>Your Sync password:</label>
                                <input type="password" placeholder="Password" value="" id="password" formControlName="password" required
                                    class="input-lg form-control login-form-control" name="password" 
                                    syncShowHidePassword
                                    identity="luserinvitepass" />
                            </div>
                        </ng-container>
                        <ng-container *ngIf="show2FA">
                            <label>2FA Code:</label>
                            <input type="twofacode" name="twofacode" id="token" class="input-lg form-control login-form-control" size="30"
                                    required formControlName="twofacode" />
                        </ng-container>

                    </form>
                </div>
                <div *ngIf="!declineSuccess && !acceptSuccess" class="form-group">
                    <button style="width: 100%; height: 45px; margin-bottom: 15px;" [disabled]="!passwordForm.dirty || !passwordForm.valid || spinner"
                        (click)="userReaction(true)" class="btn sync-btn btn-primary" type="button">Accept</button>
                    <button *ngIf="!show2FA" style="width: 100%; height: 45px;" (click)="userReaction(false)" class="btn btn-default" type="button">Decline</button>
                </div>
                <div class="invite-content" *ngIf="declineSuccess">
                    You have successfully declined the request to join the team.
                </div>                
                <div class="invite-content" *ngIf="acceptSuccess" style="text-align: left;">
                    <p>We are currently upgrading your account. Please be aware of the following details:</p>
                    <p>Sync will keep you informed of your account transfer but please keep in mind that this process may take some time. Important details:</p>
                    <ol>
                        <li><p>Temporary Access Restriction: While the transfer is in progress, you won't be able to access your Sync account across all your devices.</p></li>
                        <li><p>You will be notified via email as soon as your account is ready for use and then you must login into your Sync accounts.</p></li>
                    </ol>
                    <p><b>Action Required:</b></p>
                    <ol>
                        <li><p><a href="https://www.sync.com/install/" target="_blank">Click here</a> to ensure that you have the latest version of the Sync application installed. This step is mandatory to ensure that all your devices are up-to-date and the migration is successful.</p></li>
                    </ol>                    
                </div>
            </div>
            <div *ngIf="isInviteChecked && !isInviteValid && !spinner"
                class="invite-content content-override bg-warning">
                <div style="font-size: 16px; margin-bottom: 10px;">
                    <i class="fas fa-exclamation-triangle"></i>
                    <b> Error: Unable to Retrieve Invitation (#1600)</b>
                </div>
                Encountering difficulty with your invitation? Here are the likely reasons:
                <ol>
                    <li>Already Responded: You've previously accepted or declined this invitation, and the link is no longer valid.</li>
                    <li>Expired or Removed Invitation: The invitation may have expired or was removed before you could act on it. Contact Sync to request a invitation, and you'll receive a new link.</li>
                    <li>Link Error: The address provided may contain errors or was modified by your email client. Ensure the link was sent correctly and that the entire link is clickable. Alternatively, you can copy/paste the address into your browser.</li>
                </ol>
            </div>

            <hr />
            If you have any questions or concerns, please feel free to <a rel="noopener" href="https://www.sync.com/support">
                reach out.
            </a>    
        </div>
    </div>
</div>